import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Switch,
  SwitchProps,
} from '@mui/material';
import IncFormHelperText from 'components/forms/inc-form-helper-text/inc-form-helper-text.component';
import { FieldError } from 'react-hook-form';
import { IncFieldBase } from '../../fields.types';
import { forwardRef } from 'react';

export type IncSwitchBaseProps = {
  error?: FieldError;
  'data-testid'?: string;
} & IncFieldBase<SwitchProps>;

const IncSwitchBase = forwardRef(
  (
    {
      label,
      onChange,
      helperText,
      FormControlLabelProps,
      FormControlProps,
      error,
      value,
      'data-testid': dataTestId = 'IncSwitch',
      ...rest
    }: IncSwitchBaseProps,
    ref,
  ) => {
    return (
      <FormControl
        error={!!error}
        fullWidth={false}
        sx={{
          display: 'block',
        }}
        margin="normal"
        data-testid={dataTestId}
        {...(FormControlProps ?? {})}
      >
        <FormControlLabel
          control={
            <Switch
              onChange={onChange}
              checked={!!value}
              inputRef={ref}
              value={!!value ? 'on' : 'off'}
              data-testid={`${dataTestId}.Switch`}
              {...rest}
            />
          }
          label={label}
          sx={{ m: FormControlProps?.margin === 'none' ? 0 : undefined }}
          {...(FormControlLabelProps ?? {})}
        />
        <FormHelperText>
          <IncFormHelperText
            error={error}
            helperText={helperText}
            BoxProps={{ sx: { mt: -1 } }}
          />
        </FormHelperText>
      </FormControl>
    );
  },
);

export default IncSwitchBase;
